import { render } from "./bank-accounts.vue?vue&type=template&id=c7e50b2e"
import script from "./bank-accounts.vue?vue&type=script&lang=js"
export * from "./bank-accounts.vue?vue&type=script&lang=js"

import exportComponent from "/builds/commerce/central/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__